export default __webpack_public_path__ + "static/42-040ef2fcf1f06a381c013b7133bde331.png";